import { Box, Button, Card, CardContent, CardHeader, IconButton, Input, InputAdornment, Tooltip, Dialog, DialogActions, DialogTitle, FormGroup, FormControlLabel, Switch } from "@mui/material";
import { AUCTION_STATUS_OPTIONS_LIST, STATUS_OPTIONS_LIST } from "../../../utils/constants";
import React, { useEffect, useState, useCallback } from "react";
import TableFilter from "../../../components/shared/TableFilter";
import { AuctionServices } from "../../../services/AllServices";
import { Loader } from "../../../components/CustomLoader";
import DeleteIcon from "@mui/icons-material/Delete";
import errorHandler from "../../../utils/errorHandler";
import { EditOutlined, LiveTv, LiveTvTwoTone, WatchLater } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useParams } from "react-router-dom";
import ViewUserManagement from "./../ViewAuction";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { showDateTime } from "../../../utils/formatTime";
import { capitalize } from "../../../utils/helpers";
import CardLayout from "../../../layouts/CardLayout";

export default function TicketList() {
    const navigate = useNavigate();
    const [searchItem, setSearchItem] = useState("");
    const [auctionStartDate,setAuctionStartDate] = useState("");
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [status, setStatus] = useState([]);
    const [show, setShow] = useState(false);
    const [warning, setWarning] = useState("");
    const [currentStatus, setCurrentStatus] = useState(null);
    const [statusId, setStatusId] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [viewId, setViewId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loaderDelay, setLoaderDelay] = useState(false);
    const [auctionStatus, setAuctionStatus] = useState([]);
    const { id } = useParams();

    const fetchUsers = async (query) => {

        const body = {
            id: id,
            searchItem: query || "",
            pageNumber: currentPage,
            pageSize: pageSize,
            status: status,
            auctionStatus: auctionStatus,
        };
        try {
            setIsLoading(true);
            setLoaderDelay(false);
            const res = await AuctionServices.allAuction(body);
            setTimeout(() => {
                if (res.status === 200) {
                    setData(res?.data?.data?.auction?.tickets);
                    setAuctionStartDate(res?.data?.data?.auction?.startDate);
                    setTotalPages(res?.data?.data?.totalTickets);
                }
                setLoaderDelay(true);
            }, 500);
        } catch (err) {
            setData(err?.response?.data?.message?.data);
            errorHandler(err);
            setLoaderDelay(false);
        } finally {
            setIsLoading(false);
            setLoaderDelay(false);
        }
    };

    const debouncedSearch = useCallback(
        debounce((query) => fetchUsers(query), 400),
        [currentPage, pageSize, status, auctionStatus]
    );

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchItem(query);
        debouncedSearch(query);
    };

    const handlePageChange = (page) => setCurrentPage(page);

    const toggleChecked = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === "active" ? "inactive" : "active";
            const res = await AuctionServices.changeStatus({
                id,
                status: newStatus,
            });

            if (res.status === 200) {
                toast.success(res?.data?.message, { toastId: "success" });
                setRefresh(!refresh);
            } else {
                toast.error(res?.data?.message, { toastId: "error" });
            }
        } catch (err) {
            errorHandler(err);
        }
    };

    useEffect(() => {
        fetchUsers(searchItem);
    }, [currentPage, pageSize, status, refresh, auctionStatus]);

    const columns = [
        {
            name: "S.No.",
            cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            name: "Ticket Name",
            sortable: true,
            selector: (row) => capitalize(row?.name),
        },
        {
            name: "Total Ticket",
            sortable: true,
            selector: (row) => row.totalTicket,
        },
      
        {
            name: "Ticket Status",
            sortable: true,
            selector: (row) => capitalize(row.tickeStatus),
        },
        {
            name: "Action",
            center: true,
            cell: (row) => (
                <>
                    <Tooltip title="View Bidding History" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                navigate(`/bidding-control/ticket-quantity/${row?._id}/${id}/${auctionStartDate}`);
                            }   }                          
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Live Bidding" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                navigate(`/bidding-control/bidnow/${row?._id}/${id}`);
                            }}
                        >
                            <LiveTv />
                        </IconButton>
                    </Tooltip>
                </>
            ),
},
    ];

return (
    <Box>
        <CardLayout>
            <CardHeader title="All Tickets In Auction" />
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
            >
                <TableFilter
                    data={AUCTION_STATUS_OPTIONS_LIST}
                    value={auctionStatus}
                    setValue={setAuctionStatus}
                    filterName="Auction Status"
                />
                <Input
                    value={searchItem}
                    placeholder="Search"
                    onChange={handleSearchChange}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="clear-search"
                                onClick={() => {
                                    setSearchItem("");
                                    fetchUsers("");
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </Box>
            <CardContent>
                <DataTable
                    customStyles={{
                        headCells: {
                            style: {
                                fontSize: "15px",
                                fontWeight: "bold",
                            },
                        },
                    }}
                    columns={columns}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={totalPages}
                    onChangePage={handlePageChange}
                    paginationPerPage={pageSize}
                    paginationRowsPerPageOptions={[10, 20, 50]}
                    onChangeRowsPerPage={(currentRowsPerPage) =>
                        setPageSize(currentRowsPerPage)
                    }
                    progressPending={isLoading || !loaderDelay}
                    progressComponent={<Loader />}
                    className="custom"
                />
            </CardContent>
            <Dialog open={show} onClose={() => setShow(false)} className="popupbox-statis">
                <DialogTitle>{warning}</DialogTitle>
                <DialogActions className="status-box-action">
                    <Button
                        variant="outlined"
                        onClick={() => {
                            toggleChecked(statusId, currentStatus);
                            setShow(false);
                        }}
                        color="primary"
                    >
                        Yes
                    </Button>
                    <Button variant="outlined" onClick={() => setShow(false)} color="primary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            {modalShow ? (
                <ViewUserManagement
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    id={viewId}
                />
            ) : (
                ""
            )}
        </CardLayout>
    </Box>
);
}